import { createUseStyles } from 'react-jss';
import { ITheme } from '@quicktools/shared-components/styles/theme';
import { mediaQuery } from '@quicktools/shared-components/styles/helpers';

export default createUseStyles(
  ({ breakpoints }: ITheme) => ({
    inspireBtn: {
      position: 'absolute',
      right: 20,
      top: 'calc(50% - 10px)',

      [mediaQuery(910)]: {
        right: 14,
      },
      [mediaQuery(breakpoints.mobile)]: {
        top: 'calc(50% - 12px)',
      },
    },

    reviewSnippet: {
      backgroundColor: 'transparent',
      marginBottom: '0px',
      paddingBottom: '0px',

      [mediaQuery(breakpoints.tablet)]: {
        marginBottom: 16,
        marginTop: 0,
      },
    },

    rating: {
      marginTop: 16,

      [mediaQuery(breakpoints.tablet)]: {
        marginTop: 0,
      },
    },
  }),
  { name: 'Main' },
);
